import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-version-warning',
  templateUrl: './version-warning.component.html',
  styleUrls: ['./version-warning.component.scss']
})
export class VersionWarningComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }

}
